export enum Snackbar {
    SHOW = '@snackbar/show',
    HIDE = '@snackbar/hide',
    SET_BOTTOM_MARGIN = '@snackbar/setBottomMargin',
}
